export default __webpack_public_path__ + "static/media/about-us-laptop.580ee5cf.png";